import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallback from "components/ErrorBoundary/ErrorBoundaryFallback";

console.log("[guni-frontend] app bootstrap started");

ReactDOM.render(
  <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
